import React from "react"

import PopoverMenu from "../../../../core/gd-components/popover-menu/popover-menu/popover-menu"

export default function NavigationButton_showMore(event: React.MouseEvent, parentComponent: any, menuOptions?: Option[]) {
    if (!menuOptions) return

    gd.layout.contextMenu.show(event,
        <PopoverMenu options        = {menuOptions}
                     hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
        {
            component: parentComponent
        }
    )
}